export const CLUB_READY_MAX_LOCATION_PUBLISH_COUNT = 1000;
